import { Entity } from "./entity";
import { CONFIG, GameConfig } from "./config";
import { InvaderKind } from "./types";
import { drawSprite, INVADER_SPRITES } from "./sprites";

export class Invader extends Entity {
  readonly kind: InvaderKind;
  readonly points: number;
  alive = true;
  private readonly cfg: GameConfig;

  constructor(x: number, y: number, kind: InvaderKind, cfg: GameConfig = CONFIG) {
    super(x, y, cfg.swarm.invaderWidth, cfg.swarm.invaderHeight);
    this.cfg = cfg;
    this.kind = kind;
    this.points = cfg.points[kind];
  }

  draw(ctx: CanvasRenderingContext2D, frame: number): void {
    const sprite = INVADER_SPRITES[this.kind][frame % 2];
    const scale = this.cfg.swarm.invaderScale;
    const color =
      this.kind === "top"
        ? this.cfg.colors.invaderTop
        : this.kind === "mid"
        ? this.cfg.colors.invaderMid
        : this.cfg.colors.invaderBottom;
    const spriteW = sprite[0].length * scale;
    const spriteH = sprite.length * scale;
    const offsetX = (this.width - spriteW) / 2;
    const offsetY = (this.height - spriteH) / 2;
    drawSprite(ctx, sprite, this.x + offsetX, this.y + offsetY, scale, color);
  }
}
